<template>
  <div>
    <el-card>
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <span style="font-weight: bold; color: #409eff; margin-right: 10px">{{ employee }}</span>
          欢迎登录后台！您上次登录时间:{{ login_info.login_time }}(IP:{{ login_info.login_ip }})
        </div>
      </div>
    </el-card>
    <div style="padding: 50px">
      <el-row :gutter="50">
        <el-col :span="8">
          <el-card id="card1">
            <div slot="header">
              <span>今天到访客户</span>
            </div>
            <div>{{ reports.customer_visit_rec_qty }}</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card id="card2">
            <div slot="header">
              <span>今天成交客户</span>
            </div>
            <div>{{ reports.customer_qty }}</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card id="card3">
            <div slot="header">
              <span>今天回款金额</span>
            </div>
            <div>{{ reports.customer_receipt_amount }}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainDashboard',
  components: {},
  data() {
    return {
      employee: '',
      login_info: {},
      reports: {
        customer_qty: 0,
        customer_receipt_amount: '0.00',
        customer_visit_rec_qty: 0
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      await this.$api.admin.dashboard().then(res => {
        if (res.code == 200 && res.data) {
          this.login_info = res.data.login_info ?? {}
          this.reports = res.data.reports ?? {}
          this.employee = res.data.employee ?? ''
        }
      })
    }
  }
}
</script>

<style>
#card1 .el-card__header {
  color: #fff;
  background-color: #409eff;
}
#card2 .el-card__header {
  color: #fff;
  background-color: #67c23a;
}
#card3 .el-card__header {
  color: #fff;
  background-color: #e6a23c;
}
</style>
